import {
  useLanguage,
  useMockState,
  useThemeMode,
} from '@resurs-internal/rb-app-api';
import {useCrossTabAuthListener} from '../features/auth/crossTabAuth';
import React, {useEffect, useState} from 'react';
import i18n from 'i18next';
import {MockServiceWorker} from '../services/mockServiceWorker';
import {Center, ResursLoading} from '@resurs-internal/mui';
import {DemoBanner} from './main/DemoBanner';
import {AppDialogs} from './dialogs/AppDialogs';
import {AuthRefreshDialog} from './dialogs/AuthRefreshDialog';
import {BannerView} from './error/BannerView';
import {Outlet} from '@tanstack/react-router';

const languages = ['sv', 'da', 'nb', 'fi', 'en'] as const;
const ChangeLanguage = () => {
  const lang = useLanguage();
  useEffect(() => {
    const parameters = new URLSearchParams(window.location.search);
    const param = parameters.get('language');
    const language = languages.find((e) => e === param);
    if (!language) return;
    i18n.changeLanguage(language);
    lang.setValue?.(language);
  });
  return null;
};

const ChangeTheme = () => {
  const themeMode = useThemeMode();
  useEffect(() => {
    const parameters = new URLSearchParams(window.location.search);
    const param = parameters.get('theme');
    if (param === 'light' || param === 'dark' || param === 'pink') {
      themeMode.setValue?.(param);
    }
  });
  return null;
};

export const AppRoot: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const mock = useMockState();
  useCrossTabAuthListener();

  useEffect(() => {
    // Makes sure that msw starts when you refresh the page
    if (mock.isDemoMode && !MockServiceWorker.isActive()) {
      MockServiceWorker.start().finally(() => {
        setLoading(false);
      });
    }
    if (!mock.isDemoMode) {
      setLoading(false);
    }
  }, [mock.isDemoMode]);

  if (loading) {
    return (
      <Center>
        <ResursLoading />
      </Center>
    );
  }

  return (
    <>
      <ChangeLanguage />
      <ChangeTheme />
      <DemoBanner />
      <AppDialogs />
      <AuthRefreshDialog />
      <BannerView />
      <Outlet />
    </>
  );
};
